import React from "react";
import { Box, TextField, Typography } from "@mui/material";

interface CommonInputFieldProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  isValid?: boolean;
  error?: boolean;
  helperText?: string;
  width?: string | number;
  height?: string | number;
  type?: string;
  allowOnlyNumbers?: boolean;
  allowOnlyAlphabets?: boolean;
  multiline?: boolean;
  rows?: number;
  readOnly?: boolean;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

const CommonInputField: React.FC<CommonInputFieldProps> = ({
  label,
  required = false,
  placeholder = "",
  value,
  onChange,
  onBlur,
  isValid = true,
  error = false,
  helperText = "",
  width = "100%",
  height = "36px",
  type = "text",
  allowOnlyNumbers = false,
  allowOnlyAlphabets = false,
  multiline = false,
  rows,
  readOnly = false,
  inputProps,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (allowOnlyNumbers && !/^\d*$/.test(inputValue)) return;
    if (allowOnlyAlphabets && !/^[a-zA-Z\s]*$/.test(inputValue)) return;

    onChange(e);
  };

  return (
    <Box sx={{ width }}>
      {label && (
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#000000",
            mb: 0.5,
          }}
        >
          {label}
        </Typography>
      )}

      <TextField
        fullWidth
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleInputChange}
        onBlur={onBlur}
        multiline={multiline}
        rows={multiline ? rows || 4 : undefined}
        error={error}
        helperText={helperText}
        InputProps={{
          readOnly,
          sx: {
            height: multiline ? "auto" : height,
            fontSize: "12px",
            fontWeight: 400,
            backgroundColor: readOnly ? "#EEEEEE" : "#FFFFFF",
            color: "#A1A1A1",
            borderRadius: "5px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C4C4C4",
              borderWidth: "1px",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C4C4C4",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#C4C4C4",
            },
          },
        }}
        inputProps={{
          readOnly,
          style: {
            fontSize: "12px",
            fontWeight: 400,
            color: "#333333",
          },
          ...inputProps,
        }}
      />
    </Box>
  );
};

export default CommonInputField;
